import { CREDENTIAL_TYPES } from './constants';

export const buildAvailablePrograms = (availablePrograms) => availablePrograms.reduce((acc, { degreeOffering, programOffering, programId }) => {
  acc[programId] = `${degreeOffering} (${programOffering})`;
  return acc;
}, {});

export const buildAvailableProgramsOfStudy = (programsOfStudy) => programsOfStudy.reduce((acc, { id, publicAlias }) => {
  acc[id] = publicAlias;
  return acc;
}, {});

export const groupingInfo = (props) => {
  const activeCredentialType = props.activeTab?.value;
  let data;
  switch (activeCredentialType) {
    case CREDENTIAL_TYPES.DEGREE:
    case CREDENTIAL_TYPES.GRADUATE_CERTIFICATE:
      data = props.programs.map((program) => program.degreeOffering).join(', ');
      break;
    case CREDENTIAL_TYPES.SHORT_COURSE:
      data = props.universityName;
      break;
    default:
      data = '';
  }
  return data;
};
